import React from 'react'
import { Route, Switch } from 'react-router-dom'
import App from '../App'
import Admin from '../Components/Admin/Admin'

function Router() {
    return <Switch>
            <Route path="/" exact >
                <App />
            </Route>
            <Route path="/admin">
                <Admin />
            </Route>

    </Switch>;
}

export default Router
